export default [
	{name: 'HOME', icon: 'lni lni-home', to: '/app',},
	{name: 'COLLECTION', icon: 'lni lni-life-ring', to: '/app/collections',},
	{name: 'PAYMENTS', icon: 'lni lni-shopping-basket', to: '/app/payment/new',},
	{name: 'PROFILE', icon: 'lni lni-user', to: '/app/profile',},
];